<!-- Header -->
<div class="flex justify-between items-center">
  <div class="flex gap-4 items-center">
    <h3 class="text-lg font-bold">Custodian Info</h3>
    <div class="tooltip tooltip-bottom action-button" data-tip="Edit">
      <button (click)="onEdit()" class="border border-midnight rounded-md p-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-4 h-4"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
          />
        </svg>
      </button>
    </div>
    <div class="tooltip tooltip-bottom action-button" data-tip="Delete">
      <button
        (click)="onDelete()"
        class="border border-error text-error rounded-md p-1"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-4 h-4"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
          />
        </svg>
      </button>
    </div>
  </div>
  <button mat-dialog-close class="self-start">
    <img
      class="my-0"
      width="16"
      height="16"
      alt="Close"
      src="assets/icons/close.svg"
    />
  </button>
</div>

<!-- Body -->
<div class="flex flex-col gap-4">
  <!-- Buttons top -->
  <div class="flex gap-4 hidden">
    <button
      class="btn btn-outline normal-case rounded-full min-w-[92px] btn-xs"
      (click)="onEdit()"
    >
      Edit
    </button>
    <button
      class="btn btn-outline btn-error normal-case rounded-full min-w-[92px] btn-xs"
      (click)="onDelete()"
    >
      Delete
    </button>
  </div>

  <ng-container
    *ngTemplateOutlet="
      custodianField;
      context: {
        label: 'Name',
        value: custodianInfo.eJournalCustodianName
      }
    "
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      custodianField;
      context: {
        label: 'Email',
        value: custodianInfo.eJournalCustodianEmail
      }
    "
  ></ng-container>
</div>

<ng-template #custodianField let-label="label" let-value="value">
  <div class="flex flex-col gap-2 text-midnight">
    <p class="m-0 text-midnight">{{ label }}</p>
    <p class="m-0 font-bold text-midnight">{{ value }}</p>
  </div>
</ng-template>

<!-- Delete confirmation template -->
<ng-template #deleteConrimationTemplate>
  <div class="flex flex-col gap-6">
    <!-- Header -->
    <div class="flex justify-between items-center">
      <h3 class="text-lg font-bold">Delete custodian info?</h3>
      <button mat-dialog-close class="self-start">
        <img
          class="my-0"
          width="16"
          height="16"
          alt="Close"
          src="assets/icons/close.svg"
        />
      </button>
    </div>

    <!-- Message -->
    <p class="m-0">
      Are you sure you want to delete this custodian info? <br />
      This action cannot be undone.
    </p>

    <!-- Buttons -->
    <div class="flex justify-center gap-4">
      <button
        mat-dialog-close
        class="btn btn-outline normal-case rounded-full min-w-[120px] min-h-[40px] h-10"
      >
        Cancel
      </button>
      <button
        class="btn btn-outline btn-error normal-case rounded-full min-w-[120px] min-h-[40px] h-10"
        (click)="deleteCustodianInfo()"
      >
        Delete
      </button>
    </div>
  </div>
</ng-template>
